module.exports = __webpack_public_path__ + "img/tooltip.1be99068.svg";